import FeedbackModal from "./Container";

export default FeedbackModal;
export type { FeedbackModalProps } from "./Container";
